import { IComponentOptions } from "angular";
import { MachineDetailSpecificController } from "./controller";

export const vsComponentName = "machineDetailSpecific";

export const machineDetailSpecificComponentOptions: IComponentOptions = {
  controller: MachineDetailSpecificController,
  controllerAs: "machineDetailSpecificController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machine: "<",
    machineConfiguration: "<",
    reportGroup: "<",
  },
};
